import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/index.css' // 引入自己公共的样式
import '@/assets/css/app.less' // 引入自己公共的样式
import '@/assets/css/keyframes.css' // 引入自己公共的样式-动画
import '@/utils/index' // 引入全局的函数方法
import '@/utils/mixIn' // 引入自己写的mixIn(vue的混入方法)
import * as filter from '@/filter/index' // 全局定义自己封装的过滤器
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import axiosApi from '@/request/http.js'
import Base64 from '@/utils/base64.js' // query传参加密
// 或者在 main.js 里将它注册为全局组件
// import 'ant-design-vue/dist/antd.css'
// // 导入富文本编辑器
// import yarn s from 'vue-quill-editor'
// // 导入富文本编辑器样式
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(axiosApi)
Vue.prototype.$Base64 = Base64 // query传参加密
// 将富文本编辑器，注册为全局可用组件
// Vue.use(VueQuillEditor)
// 时间戳显示
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
